import styled from "styled-components"
import { device } from "breakpoints"

import { getGradient } from "helpers/getGradient"
import { getSolidColor } from "../../utils/helpers/getSolidColor"
import { Button } from "../Button"
import { Label } from "../Button/style"

import { Teaser } from "../Teaser"
import { Title, Excerpt, InfoWrapper, ImageWrapper } from "../Teaser/style"

export const InternalRHSCTAButton = styled(Button)`
  ${Label} {
    font-weight: 600;
    font-size: 16px;
    color: #000;
    letter-spacing: -0.12px;
    line-height: 24px;
    position: relative;
    background: transparent;
    border: none;
    padding: 0;

    @media ${device.large} {
      font-size: 18px;
      letter-spacing: -0.14px;
      line-height: 27px;
    }

    :after {
      content: "";
      height: 1px;
      width: 100%;
      position: absolute;
      bottom: 9px;
      left: 0;
      background-image: ${props => getGradient(props.theme.site)};
      @media ${device.desktop} {
        bottom: 12px;
      }
    }
  }
`

export const InternalRHSCustomTeaser = styled(Teaser)`
  box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  padding-bottom: 30px;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
  width: 100%;
  display: block;

  @media ${device.tablet} {
    margin-right: 10px;
    width: 50%;
  }
  @media ${device.desktop} {
    width: 100%;
    margin-right: 0;
    :hover {
      cursor: pointer;
      ${InternalRHSCTAButton} {
        :after {
          opacity: 0;
        }
      }
      ${Title} {
        color: ${props => getSolidColor(props.theme.site)};
      }
    }
  }

  @media ${device.large} {
    padding: 0;
    padding-bottom: 32px;
  }

  :before,
  :after {
    background-image: ${props => getGradient(props.theme.site)};
    content: "";
    display: block;
    height: 1px;
    left: 50%;
    position: absolute;
    right: 0;
    transform-origin: 50%;
    z-index: -1;
    width: 100%;
  }

  :before {
    z-index: 1;
    bottom: 70px;
    transform: rotate(-35deg) translateX(-50%);

    @media ${device.large} {
      bottom: 80px;
    }
  }

  :after {
    z-index: 1;
    bottom: 40px;
    transform: rotate(-11deg) translateX(-30%);

    @media ${device.large} {
      bottom: 50px;
    }
  }

  ${Title} {
    font-weight: 600;
    font-size: 19px;
    color: #000000;
    letter-spacing: -0.42px;
    line-height: 24px;
    text-transform: lowercase;
    margin-bottom: 16px;

    ::first-letter {
      text-transform: uppercase;
    }

    @media ${device.large} {
      font-size: 23px;
      letter-spacing: -0.5px;
      line-height: 28px;
      margin-bottom: 22px;
    }
  }

  ${Excerpt} {
    font-weight: 500;
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.12px;
    line-height: 24px;
    margin-bottom: 11px;

    @media ${device.large} {
      font-size: 17px;
      letter-spacing: -0.14px;
      line-height: 27px;
      margin-bottom: 8px;
    }
  }
  ${InfoWrapper} {
    padding-top: 16px;
    padding-left: 30px;
    @media ${device.desktop} {
      padding-top: 21px;
    }
  }
  ${ImageWrapper} {
    @media ${device.desktop} {
      padding-top: 67.6%;
    }
    @media ${device.large} {
      padding-top: 61%;
    }
  }
`
